import { render, staticRenderFns } from "./RouterLinkIgnoreDuplicate.vue?vue&type=template&id=5e7ab688&scoped=true"
import script from "./RouterLinkIgnoreDuplicate.vue?vue&type=script&lang=ts"
export * from "./RouterLinkIgnoreDuplicate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ab688",
  null
  
)

export default component.exports